export default __webpack_public_path__ + "static/media/print.568a9b4a.svg";